import React from "react";
import {
  getEnabledPassportQualityTiers,
  getPassportQualityTier,
} from "../config/passportPhotoMakerFeatures";
import "./PassportQualityPicker.css";

/**
 * Inline "Choose Quality" cards for Passport Photo Maker (setup stage).
 */
const PassportQualityPicker = ({
  selectedId = "medium",
  onSelect = () => {},
  disabled = false,
  tiers: tiersProp,
}) => {
  const tiers = getEnabledPassportQualityTiers(tiersProp);
  const selected = getPassportQualityTier(selectedId, tiersProp);

  return (
    <div className="appm-quality" id="appm-quality-section">
      <p className="appm-quality__heading">Choose Quality</p>
      <div
        className="appm-quality__list"
        role="listbox"
        aria-label="Choose quality"
      >
        {tiers.map((tier) => {
          const isSelected = selected?.id === tier.id;
          return (
            <button
              key={tier.id}
              type="button"
              role="option"
              aria-selected={isSelected}
              className={`appm-quality__card${isSelected ? " is-selected" : ""}`}
              disabled={disabled}
              onClick={() => onSelect(tier.id)}
            >
              <span className="appm-quality__credits">
                {tier.credits}&nbsp;credits
              </span>
              <span className="appm-quality__label">{tier.label}</span>
              <span className="appm-quality__meta">{tier.hint}</span>
              <span
                className={`appm-quality__check${isSelected ? " is-checked" : ""}`}
                aria-hidden="true"
              >
                {isSelected ? "✓" : null}
              </span>
            </button>
          );
        })}
      </div>
      <p className="appm-quality__notice" role="note">
        Credits are deducted per generation.
      </p>
    </div>
  );
};

export default PassportQualityPicker;
